import { PerformanceTrack } from '@mi/performance-track';

const LAST_TRACKED_SUB_APP_KEY = '__performance_last_tracked_subapp__';
const PENDING_RELOAD_SUB_APP_KEY = '__performance_pending_reload_subapp__';

function getSubAppName(pageUrl = '') {
  return pageUrl.match(/^\/main-([^/]+)/)?.[1] || '';
}

function getPerformanceStorageItem(key: string) {
  try {
    return sessionStorage.getItem(key) || '';
  } catch (error) {
    return '';
  }
}

function setPerformanceStorageItem(key: string, value = '') {
  try {
    if (value) {
      sessionStorage.setItem(key, value);
    } else {
      sessionStorage.removeItem(key);
    }
  } catch (error) {
    // ignore storage write errors
  }
}

let lastTrackedSubAppName =
  getPerformanceStorageItem(LAST_TRACKED_SUB_APP_KEY) || getSubAppName(location.pathname);
let pendingReloadSubAppName = getPerformanceStorageItem(PENDING_RELOAD_SUB_APP_KEY);

export function markPerformanceCrossAppNavigation(nextSubAppName = '') {
  const currentSubAppName = getSubAppName(location.pathname);

  if (!currentSubAppName || !nextSubAppName || currentSubAppName === nextSubAppName) {
    return;
  }

  lastTrackedSubAppName = currentSubAppName;
  pendingReloadSubAppName = nextSubAppName;
  setPerformanceStorageItem(LAST_TRACKED_SUB_APP_KEY, currentSubAppName);
  setPerformanceStorageItem(PENDING_RELOAD_SUB_APP_KEY, nextSubAppName);
}

export function initPerformanceTrack() {
  const envMap = {
    development: 'dev',
    test: 'test',
    pre: 'pre',
    production: 'pro'
  };
  const env = envMap[process.env.VUE_APP_ENV as keyof typeof envMap] as
    | 'dev'
    | 'test'
    | 'pre'
    | 'pro';
  const perfTrack = new PerformanceTrack(
    {
      // username: displayName, // 非必填，建议上报
      // userId: userName,      // 非必填，建议上报
      group: 'RETAIL', // 非必填，建议上报
      system: '国际零售工作台', // 必填，尽量使用中文
      env, // 非必填，建议上报
      domObserver: {
        '/main-global-retail-workbench/personnel-management/files':
          '.hi-v5-collapse-panel__content',
        '/main-global-retail-operation/so-management/sales-imei': '.mb-4.flex.gap-4',
        '/main-global-retail-workbench/(personnel-management/staff-store|personnel-particulars/departure)':
          '.hi-v5-pagination',
        '/main-global-channel-retail/Store/manage/info/details': '.ecy-block__header_border',
        '/main-global-position-patrol/FrontInspection': '.hi-v5-pagination'
      },
      traceConfig: {
        enable: true
      },
      whiteList: [/^\/$/, /\/main-global-retail\//, /\/main-global-channel-retail\//], // 根路径 / 和 新零售的零售通工作台不在这里上传
      domWait: 2000, // 非必填, 接口响应不超过2s可不传
      manualTrack: true, // 非必填，不对参数做处理的话可不传
      distinctSearch: false, // 非必填，search参数代表不同页面时该值设为true
      excludeRequests: [
        /\.(js|css|html)$/,
        'https://sentry.d.xiaomi.net/api/',
        'https://tracking.miui.com/track/v4/js_a',
        'https://alisgp-sentry.d.xiaomi.net/api/',
        'https://sdkconfig.ad.intl.xiaomi.com/api/',
        'https://api-whale.data.mioffice.cn/',
        /api-whale\.data\.mioffice\.cn/ // 过滤数鲸的所有网络请求（任意协议、路径）
      ] // 非必填，过滤符合条件的网络请求
    },
    // 回调函数，可不传
    (result, status) => {
      console.log('performance result =======', { result, status });
      const currentSubAppName = getSubAppName(result.pageUrl) || getSubAppName(location.pathname);
      const isPendingSubAppReload =
        pendingReloadSubAppName && currentSubAppName === pendingReloadSubAppName;
      const isCrossSubAppNavigate =
        currentSubAppName && lastTrackedSubAppName && currentSubAppName !== lastTrackedSubAppName;
      if (isPendingSubAppReload || isCrossSubAppNavigate) {
        result.loadType = 'reload';
      }
      if (currentSubAppName) {
        lastTrackedSubAppName = currentSubAppName;
        setPerformanceStorageItem(LAST_TRACKED_SUB_APP_KEY, currentSubAppName);
      }
      if (isPendingSubAppReload) {
        pendingReloadSubAppName = '';
        setPerformanceStorageItem(PENDING_RELOAD_SUB_APP_KEY);
      }
      // manualTrack为true时处理数据后调用trackData方法手动上报
      // 长页面使用自动计算的加载时间时需要用到下面这一行配置
      // result.useFmp = 1
      // 其他辅助字段
      // result.module = '子模块'
      perfTrack.trackData(result);
    }
  );
  // 测试通过后只最好只上报生产数据
  perfTrack.initTrack();
}
